import { CamcTextMediaCarousel } from "./camc-orbit";
import youkuHandler from "./camc-text-media-block-youku";

$(() => {
    // Initialize carousels
    $(".camc-text-media-block-carousel-wrapper").each((index, item) => {
        const $item = $(item);
        const orbitTimerDelay = parseInt($item.find(".orbit").attr("data-timer-delay"), 10);
        const camcTextMediaCarousel = new CamcTextMediaCarousel(item, orbitTimerDelay);
        camcTextMediaCarousel.setup();
        const orbitInstance = camcTextMediaCarousel.getInstance();

        // Initialize Youku items within the carousel
        $item.find(".youku-carousel").each((index, youkuItem) => {
            const $youkuItem = $(youkuItem);
            const youkuObj = new youkuHandler($youkuItem.attr("id"), orbitInstance);
            youkuObj.setup();
        });
    });

    // Initialize single Youku items
    $(".youku-single").each((index, youkuItem) => {
        const $youkuItem = $(youkuItem);
        const youkuObj = new youkuHandler($youkuItem.attr("id"));
        youkuObj.setup();
    });
});
